import { render, staticRenderFns } from "./blog-12.vue?vue&type=template&id=79b2edad&scoped=true"
import script from "./blog-12.vue?vue&type=script&lang=js"
export * from "./blog-12.vue?vue&type=script&lang=js"
import style0 from "./blog-12.vue?vue&type=style&index=0&id=79b2edad&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "79b2edad",
  null
  
)

export default component.exports